function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 100,
  height: 100,
  viewBox: "0 0 100 100",
  role: "img"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "m55.431 41.056-6.457 11.185a11 11 0 0 0-1.474 5.5v22.258H37V54.927a11 11 0 0 1 1.474-5.5l7.874-13.64-6.22-2.222a2 2 0 0 1-.186-3.69l20.588-9.778a1 1 0 0 1 1.426.823l1.826 22.733a2 2 0 0 1-3.284 1.687z"
}));
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/directions/ic-turn-slightly-right.svg";
export { SvgComponent as ReactComponent };